import * as React from "react";
import { UserContext } from "../context/UserContext";
import {
  Billogram,
  BillogramStatus,
  StatusResponseStatus
} from "../api/ApiClient";
import { thousandSeparator } from "../services/StringUtil";

interface Props {}

enum Status {
  IDLE,
  FETCHING,
  ERROR,
  DONE
}

interface State {
  invoices: Billogram[];
  status: Status;
}

export class Invoices extends React.Component<Props, State> {
  static contextType = UserContext;
  context!: React.ContextType<typeof UserContext>;

  private fetchingMore: boolean = false;
  private page: number = 1;

  state = {
    invoices: [],
    status: Status.IDLE
  };

  async componentDidMount() {
    this.fetchMore();
  }

  render() {
    return (
      <div>
        <h2>Mina fakturor</h2>

        <table className="invoice-table">
          <thead>
            <tr>
              <th>Månad</th>
              <th>Belopp</th>
              <th>Faktura</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {this.state.invoices.map((invoice: Billogram) => {
              let status: string;
              switch (invoice.status) {
                case BillogramStatus.PAID:
                  status = "Betald";
                  break;
                case BillogramStatus.UNPAID:
                  status = "Obetald";
                  break;
                case BillogramStatus.ENDED:
                  status = "Avslutad";
                  break;
                case BillogramStatus.SCHEDULED:
                  status = "Betalning pågår";
                  break;
              }
              return (
                <tr key={invoice.id}>
                  <td>{invoice.invoiceDate.format("MMMM")}</td>
                  <td>{thousandSeparator(invoice.totalSum)} kr</td>
                  <td>
                    <a href={invoice.url} target="_blank">
                      Öppna i Billogram
                    </a>
                  </td>
                  <td>{status}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="mt-2">
          {this.state.status == Status.FETCHING && <p>Hämtar fakturor...</p>}
          {this.state.status == Status.ERROR && (
            <React.Fragment>
              <p>Något gick fel när dina fakturor skulle hämtas</p>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={this.fetchMore}>
                Prova igen
              </button>
            </React.Fragment>
          )}
          {this.state.status == Status.DONE &&
            this.state.invoices.length == 0 && (
              <p>Inga fakturor finns än så länge</p>
            )}
          {this.state.status != Status.DONE &&
            this.state.invoices.length > 0 &&
            this.state.status != Status.FETCHING && (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={this.fetchMore}>
                Hämta fler
              </button>
            )}
          {this.state.status == Status.DONE &&
            this.state.invoices.length > 10 && <p>Alla fakturor är hämtade</p>}
        </div>
      </div>
    );
  }

  fetchMore = async () => {
    if (this.fetchingMore) {
      return;
    }
    this.fetchingMore = true;
    this.setState({ status: Status.FETCHING });

    try {
      let newInvoices = await this.context.getClient().invoices(this.page);
      this.fetchingMore = false;
      this.page++;
      let invoices = this.state.invoices.slice(0);
      invoices.push(...newInvoices);
      this.setState({
        invoices,
        status: newInvoices.length < 10 ? Status.DONE : Status.IDLE
      });
    } catch (error) {
      this.fetchingMore = false;
      this.setState({ status: Status.ERROR });
      console.error("Failed to fetch invoices", error);
    }
  };
}
